// Valuta opmaak instellingen
const currencyFormats = {
  "USD": { symbolBefore: true, symbol: "$" },
  "GBP": { symbolBefore: true, symbol: "£" },
  "EUR": { symbolBefore: true, symbol: "€" },
  "CAD": { symbolBefore: true, symbol: "$" },
  "AUD": { symbolBefore: true, symbol: "$" },
  "PLN": { symbolBefore: false, symbol: "zł" },
  "BGN": { symbolBefore: false, symbol: "лв" },
  "HUF": { symbolBefore: false, symbol: "Ft" },
  "CZK": { symbolBefore: false, symbol: "Kč" },
  "SEK": { symbolBefore: false, symbol: "kr" },
  "DKK": { symbolBefore: false, symbol: "kr" },
  "RON": { symbolBefore: false, symbol: "lei" },
  "CHF": { symbolBefore: true, symbol: "CHF" },
  "NZD": { symbolBefore: true, symbol: "$" },
};

// Gratis verzending drempels voor tandenborstel
const toothbrushThresholds = {
  "USD": 90,
  "GBP": 70,
  "EUR": 80,
  "CAD": 125,
  "AUD": 140,
  "PLN": 335,
  "BGN": 156,
  "HUF": 32000,
  "CZK": 200000,
  "SEK": 880,
  "DKK": 600,
  "RON": 400, 
  "CHF": 80,
  "NZD": 145,
};

// Gratis verzending drempels voor borstelkoppen
const brushHeadThresholds = {
  "USD": 45,
  "GBP": 35,
  "EUR": 40,
  "CAD": 60,
  "AUD": 70,
  "PLN": 170,
  "BGN": 80,
  "HUF": 16000,
  "CZK": 1000,
  "SEK": 430,
  "DKK": 300,
  "RON": 200, 
  "CHF": 40, 
  "NZD": 75,
};

// Valuta weergave formatteren
function formatCurrencyDisplay(amount, currencyCode) {
  const format = currencyFormats[currencyCode] || { symbolBefore: true, symbol: currencyCode };
  
  if (format.symbolBefore) {
    return `${format.symbol}${amount}`;
  } else {
    return `${amount}${format.symbol}`;
  }
}

// Verzendkosten bericht bijwerken
function updateFreeShippingMessage() {
  const currentCurrency = Shopify.currency.active;
  
  // Get locale for language detection
  const locale = document.documentElement.lang || "en";
  
  // Set message based on locale
  let message = "Free shipping from";
  if (locale.includes("nl")) {
    message = "Gratis verzending vanaf";
  } else if (locale.includes("fr")) {
    message = "Livraison gratuite à partir de";
  } else if (locale.includes("de")) {
    message = "Kostenloser Versand ab";
  } else if (locale.includes("es")) {
    message = "Envío gratis desde";
  }
  
  // Update toothbrush message
  const toothbrushElements = document.querySelectorAll('.free-shipping-message');
  const toothbrushThreshold = toothbrushThresholds[currentCurrency] || toothbrushThresholds["USD"];
  const formattedToothbrushThreshold = formatCurrencyDisplay(toothbrushThreshold, currentCurrency);
  
  toothbrushElements.forEach(element => {
    element.textContent = `${message} ${formattedToothbrushThreshold}`;
  });
  
  // Update brush heads message
  const brushHeadElements = document.querySelectorAll('.second-product-shipping');
  const brushHeadThreshold = brushHeadThresholds[currentCurrency] || brushHeadThresholds["USD"];
  const formattedBrushHeadThreshold = formatCurrencyDisplay(brushHeadThreshold, currentCurrency);
  
  brushHeadElements.forEach(element => {
    element.textContent = `${message} ${formattedBrushHeadThreshold}`;
  });
}

// Initialiseren
document.addEventListener('DOMContentLoaded', function() {
  updateFreeShippingMessage();
  
  document.addEventListener('currency_switcher:change', function(event) {
    updateFreeShippingMessage();
  });
  
  if (typeof Currency !== 'undefined' && Currency.hasOwnProperty('convertAll')) {
    const originalConvertAll = Currency.convertAll;
    Currency.convertAll = function() {
      originalConvertAll.apply(Currency, arguments);
      setTimeout(updateFreeShippingMessage, 100);
    };
  }
});